import React from 'react';
import Bill from '../Bill';

const PhoneBillCardList = ({
  bills,
  onUpdatePaidDate,
  bankAccountId,
  onDelete,
  showAllBills,
  bankAccounts,
  emptyMessage = 'No bills in this section.',
}) => {
  if (!bills || bills.length === 0) {
    return <p className="phone-bills-empty">{emptyMessage}</p>;
  }

  return (
    <div className="phone-bill-card-list">
      {bills.map((bill) => (
        <Bill
          key={bill.id}
          bill={bill}
          layout="card"
          onUpdatePaidDate={onUpdatePaidDate}
          bankAccountId={bankAccountId}
          onDelete={onDelete}
          showAllBills={showAllBills}
          bankAccounts={bankAccounts}
        />
      ))}
    </div>
  );
};

export default PhoneBillCardList;
